/* Tiny shared building blocks reused across pages so structure stays uniform. */

export function PageHead({ title, sub, actions }) {
  return (
    <div className="page-head">
      <div>
        <h1>{title}</h1>
        {sub && <div className="sub">{sub}</div>}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </div>
  );
}

export function FilterBox({ label, children }) {
  return (
    <label className="fbox">
      <span>{label}</span>
      {children}
    </label>
  );
}

export function Spinner({ label = "Loading…" }) {
  return <div className="loading-dots">{label}</div>;
}

export function Empty({ children = "Nothing here yet." }) {
  return <div className="empty">{children}</div>;
}

/* Mode badge — port of shell.js modeBadge: paper / testnet / live pill. */
export function ModeBadge({ obj }) {
  if (!obj) return null;
  if (obj.dry_run) return <span className="badge paper">paper</span>;
  const tn = (obj.key && obj.key.testnet) || obj.testnet;
  if (tn) return <span className="badge testnet">testnet</span>;
  return <span className="badge live">live</span>;
}
